import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

const LoadContainer = Loadable({ loader: () => import('layers/asudd/containers/LoadContainer/LoadContainer'), loading })
const MapPage       = Loadable({ loader: () => import('layers/asudd/pages/MapPage/MapPage'), loading })


export default (links) => (
  <Route component={LoadContainer}>
    <Route path={links.root} component={MapPage} />

    <Redirect path={`${links.root}/*`} to={links.root} />
  </Route>
)
